export default __webpack_public_path__ + "static/media/05-wai.fa736ed6.jpg";